import { defineEntity, custom } from './_helpers.js';

export default defineEntity('assessment', {
    started:   custom({ scope: 'state' }),
    completed: custom({ scope: 'state' }),
});
